export default "__VITE_PUBLIC_ASSET__9f703508__"